import { AccountInfo } from '@azure/msal-browser';
import axios, { AxiosError } from 'axios';
import { MsalInstance } from '../../MsalInstance';

interface ResponseErrorResolverProps {
  error: AxiosError;
  account: AccountInfo | null;
  instance: MsalInstance;
}

export const responseErrorResolver = async ({
  error,
  account,
  instance,
}: ResponseErrorResolverProps) => {
  if (error?.response?.status === 401 && account && error.config) {
    try {
      const accessToken = await instance.getAccessToken(account);

      instance.setAccessTokenOnHeader(error.config, accessToken);

      // retry the request with the new token
      return axios(error.config);
    } catch (e) {
      await instance.logoutRedirect({ account });
    }
  }

  return Promise.reject(error);
};
